import { LastModifiedBy } from '../types/shared';
import { UserProfile, ProjectMember } from '../features/auth/types';

/**
 * Creates a LastModifiedBy object from current user context.
 * Used by all mutation actions to populate audit trail metadata.
 * 
 * @param user - Current authenticated user
 * @param member - Current project member (contains role info)
 * @returns LastModifiedBy object or undefined if user not authenticated
 */
export function createLastModifiedBy(
    user: UserProfile | null,
    member: ProjectMember | null
): LastModifiedBy | undefined {
    if (!user) return;
    
    // Get role name from member, fallback to 'viewer' if not available
    const roleName = member?.roleId || 'viewer';
    
    return {
        userId: user.uid,
        userName: user.displayName || user.email,
        role: roleName,
        timestamp: Date.now()
    };
}
